import Cookies from "js-cookie";
import {getCookie} from "../../utils/support";

const provider = {
  state: {
    providerCode:Cookies.get('providerCode'),
    providerId:Cookies.get('providerId'),
  },
  mutations: {
    providerCode(state,provider){//添加时存code
      state.providerCode=provider.providerCode
      state.providerId=provider.providerId
      Cookies.set('providerCode',provider.providerCode)
      Cookies.set('providerId',provider.providerId)
    },

  },
  actions: {
    providerCode({commit},provider){
      commit('providerCode',provider)
    }
  }
}

export default provider



// WEBPACK FOOTER //
// ./src/store/modules/provider.js